export async function api(path, options = {}) {
  const response = await fetch(path, {
    ...options,
    headers: options.body
      ? { 'content-type': 'application/json', ...(options.headers || {}) }
      : options.headers,
  });
  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json')
    ? await response.json().catch(() => ({}))
    : await response.text();
  if (!response.ok) {
    const error = new Error(data?.error || data?.message || `Request failed (${response.status})`);
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
}

export function money(cents, currency = 'USD') {
  const locale = ({ USD: 'en-US', EUR: 'en-IE', GBP: 'en-GB' })[currency] || 'en-US';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: Number(cents) % 100 ? 2 : 0,
  }).format(Number(cents || 0) / 100);
}

export function formatDate(value) {
  if (!value) return 'Not crawled yet';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Unknown date';
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
}

export function sourceLabel(key) {
  return ({ press: 'Web', youtube: 'YouTube', twitch: 'Twitch', tiktok: 'TikTok', rss: 'Custom RSS' })[key] || key;
}
